module.exports = __webpack_public_path__ + "static/img/hil_done.94005ff9.png";